import { matchPath, useLocation } from 'quartz-routing/react-router';
import { MYLEARNING_URL_FRAGMENT } from '../../routes/academyRoutePaths';
export const useIsCatalogSearchPage = () => {
  const location = useLocation();
  const isCatalogResultsPage = location.pathname.match(/^\/results\/?$/i);
  return isCatalogResultsPage;
};
export const useIsPartnerSearchPage = () => {
  const location = useLocation();
  const isPartnerSearchPage = location.pathname.match(/^\/partners\/?$/i);
  return isPartnerSearchPage;
};
export const useIsMyLearningPage = () => {
  const {
    pathname
  } = useLocation();
  return !!matchPath(pathname, {
    path: MYLEARNING_URL_FRAGMENT
  });
};